/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Deposit_DueInputs */

const en_queue_sos_deposit_due = /** @type {(inputs: Queue_Sos_Deposit_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders with a deposit not paid`)
};

/**
* | output |
* | --- |
* | "Sales orders with a deposit not paid" |
*
* @param {Queue_Sos_Deposit_DueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_deposit_due = /** @type {((inputs?: Queue_Sos_Deposit_DueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Deposit_DueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_deposit_due(inputs)
});